export const calculateHolidayHours = (staff, holidayLength, workingDays = 1) => {
  const isZeroHours = staff?.ContractType === "0 Hours" || staff?.ContractType === 0;
  const weeklyHours = Number(isZeroHours ? staff?.AverageHours : staff?.ContractedHours);
  const contractedDays = Number(isZeroHours ? staff?.AverageDays : staff?.ContractedDays);

  if (!Number.isFinite(weeklyHours) || !Number.isFinite(contractedDays) || contractedDays <= 0) {
    return 0;
  }

  const hoursPerDay = weeklyHours / contractedDays;

  if (holidayLength === "Half") return hoursPerDay / 2;
  if (holidayLength === "Block") return hoursPerDay * Math.max(0, Number(workingDays) || 0);
  return hoursPerDay;
};